import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;
export const researchExtensionPostDocUpload = async (data) => {
  api.post(API_URL + "research-extension", data);
};

export const getResearchExtension = async (re_id) => {
  return api
    .get(API_URL + `research-extension/${re_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getResearchExtensionMentor = async (mentor_id) => {
  return api
    .get(API_URL + `research-extension/mentor/${mentor_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getResearchExtensionAdmin = async () => {
  return api
    .get(API_URL + `research-extension/admin`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const confirmResearchExtensionMentor = (re_id, confirm) => {
  return api
    .put(`${API_URL}research-extension/${re_id}/4/${confirm}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const confirmResearchExtensionAdmin = (re_id, confirm) => {
  return api
    .put(`${API_URL}research-extension/${re_id}/5/${confirm}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getResearchExtensionByStdId = async (std_id) => {
  return api
    .get(API_URL + `research-extension/std/${std_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};
